(function() {
var GarageEntriesForm,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

GarageEntriesForm = (function() {
  function GarageEntriesForm() {
    this.update_ui = bind(this.update_ui, this);
    this.clicked_on_item = bind(this.clicked_on_item, this);
    this.set_selection_state = bind(this.set_selection_state, this);
    this.set_max_equipments = bind(this.set_max_equipments, this);
    this.print_state = bind(this.print_state, this);
    this.set_selected_items_field = bind(this.set_selected_items_field, this);
    this.setup_listeners = bind(this.setup_listeners, this);
    this.clear_state = bind(this.clear_state, this);
    console.log("GarageEntriesForm.constructor: new garage_entries_form");
  }

  GarageEntriesForm.prototype.clear_state = function() {
    console.log("GarageEntriesForm.clear_state");
    this.selected_items_field_selector = "#garage_item_entry_form_selected_items";
    this.selected_items = [];
    return this.max_equipments = null;
  };

  GarageEntriesForm.prototype.setup_listeners = function() {
    $(document).off("click", ".garage_item_select_button");
    $(document).off("click", "[data-dismiss]");
    $(document).off("click", "#save_selection_button");
    $(document).on("click", ".garage_item_select_button", (function(_this) {
      return function(event) {
        event.preventDefault();
        return _this.clicked_on_item(event);
      };
    })(this));
    $(document).on("click", "[data-dismiss]", (function(_this) {
      return function(event) {
        return _this.clear_state();
      };
    })(this));
    return $(document).on("click", "#save_selection_button", (function(_this) {
      return function(event) {
        console.log("save selection button clicked");
        if (_this.selected_items.length === 0) {
          if ($(".garage_item_selection").length !== 0) {
            event.preventDefault();
            return alert("You must click the 'select' button on an item to select it first, then click the 'save selection' button");
          }
        }
      };
    })(this));
  };

  GarageEntriesForm.prototype.set_selected_items_field = function(selector) {
    return this.selected_items_field_selector = selector;
  };

  GarageEntriesForm.prototype.print_state = function() {
    console.log("--------------------");
    console.log("Max Equipments: " + this.max_equipments);
    console.log("Selected_items: " + this.selected_items);
    return console.log("--------------------");
  };

  GarageEntriesForm.prototype.set_max_equipments = function(max_equipments) {
    return this.max_equipments = max_equipments;
  };

  GarageEntriesForm.prototype.set_selection_state = function(selected_items_list) {
    var i, id, len, ref;
    console.log("set_selection_state: selected_items_list: " + selected_items_list);
    if (!selected_items_list) {
      console.log("not selected_items_list: ");
      this.selected_items = [];
    } else {
      console.log("not selected_items_list: splitting array");
      this.selected_items = [];
      ref = selected_items_list.split(",");
      for (i = 0, len = ref.length; i < len; i++) {
        id = ref[i];
        console.log("id: " + id);
        this.selected_items.push(+id);
      }
    }
    return console.log("@selected_items is " + this.selected_items);
  };

  GarageEntriesForm.prototype.clicked_on_item = function(event) {
    var index, item_id;
    item_id = this.find_item_id(event);
    if (indexOf.call(this.selected_items, item_id) >= 0) {
      index = this.selected_items.indexOf(item_id);
      this.selected_items.splice(index, 1);
    } else {
      this.selected_items.push(item_id);
    }
    this.print_state();
    return this.update_ui();
  };

  GarageEntriesForm.prototype.find_item_id = function(event) {
    var $elem;
    $elem = $(event.target).closest(".garage_item_selection");
    return $elem.data("garage-selection-item");
  };

  GarageEntriesForm.prototype.update_ui = function() {
    var $button, $error_message, _num_selections, i, item_id, len, ref;
    $(".garage_item_selection").removeClass("garage_item_selected");
    $(".garage_item_select_button").text("select");
    $(this.selected_items_field_selector).val(this.selected_items.toString());
    ref = this.selected_items;
    for (i = 0, len = ref.length; i < len; i++) {
      item_id = ref[i];
      $("#garage_item_selection_" + item_id).addClass("garage_item_selected");
      $("#garage_item_select_button_" + item_id).text("de-select");
    }
    $button = $("#save_selection_button");
    $error_message = $("#too_many_equipment_error");
    console.log("selected items are: ");
    console.log(this.selected_items);
    _num_selections = this.selected_items.length;
    if (_num_selections > this.max_equipments) {
      console.log("_num_selections " + _num_selections + " > " + this.max_equipments);
      $button.prop("disabled", true);
      return $error_message.fadeIn("fast");
    } else {
      $button.prop("disabled", false);
      return $error_message.fadeOut("fast");
    }
  };

  return GarageEntriesForm;

})();

window.alpha_oms.garage_entries_form_constructor = GarageEntriesForm;

}).call(window);
